const PREVIEW_PARAM = "preview=1";

export const previewUrl = (link: { url?: string; slug?: string }): string => {
  const base = link.url || `${window.location.origin}/pay/${link.slug}`;

  return `${base}${base.includes("?") ? "&" : "?"}${PREVIEW_PARAM}`;
};
